import {
  Box,
  Button,
  Checkbox,
  Chip,
  Collapse,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../../../components/Maincard";

import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { useGetTokenOrLogout } from "../../../../utils/token";
import { useNavigate } from "react-router-dom";
import SearchTextFieldComp from "../../../newComponent/newtextfieldComp/SearchTextFieldComp";
import LoaderComp from "../../../newComponent/LoaderComp/Loader";
import CustomSnackbar from "../../../components/ui-component/snackbar/CustomSnackbar";
import SelectedItemButton from "../../../newComponent/NewButtonComp/SelectedItemButton";
import { fDate } from "../../../../utils/formatTime";
import { CSVExport } from "../../../components/ui-component/table/CSVExport";
import DetailedMetaFilter from "./DetailedMetaFiler";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;   
export default function MetaDetailedReport({ open, isDownloadAccess }) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");

  const [metaData, setMetaData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [SearchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 100,
  });
  const [selectedIds, setSelectedIds] = useState([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [visibleRowIds, setVisibleRowIds] = useState([]); // Store current page's row IDs
  const [isIndeterminate, setIsIndeterminate] = useState(false);
  const [prevPageSize, setPrevPageSize] = useState(pagination.pageSize);
  const [gridKey, setGridKey] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    setLoading(true)
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/meta-detail-report/${userId}`,
          { headers }
        );
        
        const data =await response.json();
        if (response.ok) {
          const sortedData = data
          setMetaData(sortedData);
          setOriginalData(sortedData);
          setSearchData(sortedData);
          setLoading(false);
        } else if (response.status === 404) {
          navigate("/page404");
        } else if (response.status === 401) {
          navigate("/page401");
        } else if (response.status === 403) {
          navigate("/page403");
        } else if (response.status === 400) {
          showSnackbar(data.message, "error");
          setLoading(false);
        } else {
          navigate("/page500");
        }
      } catch {
        navigate("/page500");
      }
    };

    fetchData();
  }, [userId]);

  // select code

  // Upadate current page ids when pagination is chnages
  useEffect(() => {
    setPrevPageSize(pagination.pageSize);

    // new pagesize is less than prev page size then deselct all selected ids first
    if (pagination.pageSize !== prevPageSize) {
      setSelectedIds([]);
      return;
    }

    // Update visible row IDs when pagination changes
    const currentPageRows = metaData.slice(
      pagination.page * pagination.pageSize,
      (pagination.page + 1) * pagination.pageSize
    );
    const visibleIds = currentPageRows.map((row) => row.id);
    setVisibleRowIds(visibleIds);

    // If there are no visible rows, set SelectAllChecked to false
    if (visibleIds.length === 0) {
      setIsSelectAllChecked(false);
      setIsIndeterminate(false);
      return;
    }

    // Check if all visible rows are selected
    const allVisibleSelected = visibleIds.every((id) =>
      selectedIds.includes(id)
    );
    const someVisibleSelected = visibleIds.some((id) =>
      selectedIds.includes(id)
    );

    setIsSelectAllChecked(allVisibleSelected);
    setIsIndeterminate(someVisibleSelected && !allVisibleSelected);
  }, [pagination, metaData, selectedIds]);

 

  const columns = [
    {
      field: "name",
      headerName: "Enquiry Name",

      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.first_name || ""}{" "}
${params.row?.last_name}`,
      renderCell: (params) => (
        <div>
          {" "}
          <div>
            <Button
              size="small"
              onClick={() =>
                window.open(`/enquirydetails/${params?.row?.id}`, "_blank")
              }
            >
              {params.row?.first_name}{" "}
              {params.row?.last_name ? params.row?.last_name : ""}
            </Button>
          </div>
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "phone",
      headerName: "Mobile Number",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.mobile || ""}`,
      renderCell: (params) => (
        <div>
          {" "}
          {params.row?.mobile_country_code}
          {userRole === "advisor" || userRole === "trainer"
            ? params.row?.mobile?.replace(/.(?=.{4,}$)/g, "*")
            : params.row?.mobile}
        </div>
      ),
    },
     {
      field: "email",
      headerName: "Email",

      width: 150,
      headerClassName: "header-cell",

      headerAlign: "center",
      align: "center",
    },
    {
      field: "assign_to",
      headerName: "Assign To",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.assign_to?.first_name || ""}{" "}
       ${params.row?.assign_to?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.assign_to?.first_name} {params.row?.assign_to?.last_name}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    
    {
      field: "campaign",
      headerName: "Campaign",

      width:350,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.campaign_id?.campaign_name || "",
      renderCell: (params) => (
        <div>{params.row?.campaign_id?.campaign_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "form_name",
      headerName: "Form Name",

      width:350,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.form_name || "",
      renderCell: (params) => (
        <div>{params.row?.form_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "enquiry_date",
      headerName: "Enquiry Date",

      width: 150,
      headerClassName: "header-cell",

      headerAlign: "center",
      align: "center",
    },

    {
      field: "nearest_branch",
      headerName: "Nearest  Branch",

      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.nearest_branch_id?.branch_name || "",
      renderCell: (params) => (
        <div>{params.row?.nearest_branch_id?.branch_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "service",
      headerName: "Service",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.service_id?.service_name || "",
      renderCell: (params) => <div>{params.row?.service_id?.service_name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "subService",
      headerName: "Sub Service",
      width: 250,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.sub_service_id?.name || "",
      renderCell: (params) => <div>{params.row?.sub_service_id?.name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "leadSource",
      headerName: "Lead Source",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.lead_source_type_id?.name || "",
      renderCell: (params) => (
        <div>{params.row?.lead_source_type_id?.name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "sublead",
      headerName: "Sub Lead Source",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.sub_lead_source_type_id?.source_type || "",
      renderCell: (params) => (
        <div>{params.row?.sub_lead_source_type_id?.source_type}</div>
      ),
      headerAlign: "center",
      align: "center",
    },


    
  ];

 
  useEffect(() => {
    const exportData = metaData.map((row) => ({
      name: row?.last_name
        ? `${row?.first_name} ${row?.last_name}`
        : row?.first_name,
      mobile_country_code: row?.mobile_country_code || "",
      mobile: row?.mobile || "",

      enquiry_date: fDate(row?.enquiry_date || ""),

      nearest_branch: row?.nearest_branch_id?.branch_name || "",
      service: row?.service_id?.service_name,
      sub_service: row?.sub_service_id?.name,
      lead_source: row?.lead_source_type_id?.name,
      sub_lead_source: row?.sub_lead_source_type_id?.source_type,
      prospective_level: row?.prospective_level_id?.prospective_level,
      stage: row?.stage_id?.stage_name,
      branch: row?.branch_id?.branch_name,
      assign_to: `${row?.assign_to?.first_name || ""} ${
        row?.assign_to?.last_name || ""
      }`,
      recycle_by: `${row?.recycleBy_id?.first_name || ""} ${
        row?.recycleBy_id?.last_name || ""
      }`,
      recycle_reason: row?.recycle_reason_id?.recycle_reason,
      recycle_date: fDate(row?.pros_lvl_update_date),
      status: row?.status,
    }));
    setExportData(exportData);
  }, [metaData]);

  return (
    <>
      <LoaderComp isLoading={loading} />

      <Grid container spacing={2}>
        {/* Filter comp */}
        <Grid item xs={12}>
          <Collapse in={open}>
            <MainCard>
              
            
              <DetailedMetaFilter
                metaData={metaData}
                setMetaData={setMetaData}
                originalData={originalData}
                SearchButton={SearchData}
                setSearchData={setSearchData}
                setLoading={setLoading}
                setVisibleRowIds={setVisibleRowIds}
                setIsIndeterminate={setIsIndeterminate}
                setIsSelectAllChecked={setIsSelectAllChecked}
                setSelectedid={setSelectedIds}
                setGridKey={setGridKey}
              />
            </MainCard>
          </Collapse>
        </Grid>

      

        <Grid item xs={12}>
          <MainCard>
            <DataGrid
                          key={gridKey}
                          rows={metaData}
                          columns={columns}
                          autoHeight
                          slots={{
                            noRowsOverlay: CustomNoRowsOverlay,
                          }}
                          pageSize={pagination.pageSize}
                          onPaginationModelChange={(model) => setPagination(model)}
                          pageSizeOptions={[10, 25, 50, 100]}
                          disableRowSelectionOnClick
                        />
          </MainCard>
                        
                      </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
